module.exports = __webpack_public_path__ + "assets/img/driver-btn-cbdc4d25.png";